import { createTurboAutocomplete } from '../modules/autocomplete';

createTurboAutocomplete({
  selector: '#autocomplete-installations',
  endpoint: '/installations/search.json',
  onSelect: (item) => {
    window.location.href = item.link;
  },
  options: {
    // Maquette recherche.png : 6 résultats puis « Afficher tous les résultats »
    collapsedCount: 6,
  },
});

// Le bouton « Rechercher » de la fr-search-bar relance la recherche d'autocomplete
// (pas de page de résultats dédiée à ce jour).
document.addEventListener('click', (e) => {
  if (e.target.closest('#search-installation-btn')) {
    const input = document.querySelector('#autocomplete-installations');
    if (input) {
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
});

